import { useState } from "react";
import Sidebar from "./sidebar";
import Editor from "./editor";
import Preview from "./preview";
import PageContext from "../../contexts/page";
import BlocksContext from "../../contexts/blocks";

export default function Styles() {
  const [selected, setSelected] = useState({});

  return (
    <BlocksContext>
      <div className="page">
        <div style={{ height: "100%", display: "flex", alignItems: "stretch" }}>
          <Sidebar selected={selected} setSelected={setSelected} />
          <Editor setStyle={setSelected} style={selected} />
          <Preview style={selected} />
        </div>
      </div>
    </BlocksContext>
  );
}
